import styled from '@emotion/styled';

const ThumbnailWrapper = styled('div')({
  position: 'relative',
  marginBottom: 8,
});

export default ThumbnailWrapper;
